export const AuthenticationTranslations = {
    authenticationTranslations : {
        forgotPassword : 'Se te olvidó tu contraseña',
        description: 'Ingrese el correo electrónico con el que se registró y le enviaremos una nueva contraseña.',
        confirmation: {
            message: 'Hemos enviado una contraseña temporal a su dirección de correo electrónico. Por favor revise su bandeja de entrada para el correo electrónico titulado "Password Reset".',
        }
    }
}
